module.exports = __webpack_public_path__ + "static/media/USP1Image.485a2b2c.png";